import { Fragment, ReactNode } from 'react'
import { isNil } from 'lodash'

import { ROUTE_PATH } from 'lib/paths'
import { TextDetail } from './helpers'

import { Link } from 'features/i18n/router'
import { HighlightText } from 'components'

type Props = {
  text: TextDetail
  highlightText?: string[]
}

export const Text = ({ text, highlightText }: Props) => {
  const renderText = (
    <HighlightText
      keywords={highlightText}
      // // Use this flag when insensitive Japanese applied to post search
      // insensitiveJapanese
    >
      {text.text}
    </HighlightText>
  )

  switch (text.type) {
    case 'user':
      if (isNil(text.target)) {
        return <span className="PostText__a">{renderText}</span>
      }

      return (
        <Link
          className="PostText__a"
          to={ROUTE_PATH.USER(text.target)}
          onMouseUp={(e) => e.stopPropagation()}
        >
          {renderText}
        </Link>
      )

    case 'hash':
      return (
        <Link
          className="PostText__a"
          to={ROUTE_PATH.TIMELINE_HASHTAG(text.target.toString())}
          onMouseUp={(e) => e.stopPropagation()}
        >
          {renderText}
        </Link>
      )

    case 'link':
      return (
        <a
          className="PostText__a"
          href={text.text}
          onMouseUp={(e) => e.stopPropagation()}
        >
          {renderText}
        </a>
      )

    case 'break':
      return <br />

    case 'space':
      return <Fragment> </Fragment>

    default:
      return <Fragment>{renderText}</Fragment>
  }
}
